import React from "react";
import OrderManagementLayout from "../pages/order-management/OrderManagementLayout";

const OrderManagement = () => {
    return <OrderManagementLayout />;
};

export default OrderManagement;
